export class Alert {
    type: AlertType;
    message: string;
    progress: number;
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}
